import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import "./styles/Header.css";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="user-dropdown-toggle"
    style={{ cursor: "pointer" }}
  >
    {children}
  </span>
));

export default function Header({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (key) => {
    if (key === "logout") {
      onLogout?.();
    } else {
      navigate(`/${key}`);
    }
  };

  const isActive = (key) => location.pathname.startsWith(`/${key}`);

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top" className="header-navbar">
      <Container>
        <Navbar.Brand onClick={() => navigate("/")} className="d-flex align-items-center brand-hover">
          <span className="fw-bold text-logo">CIRFlask</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto d-flex align-items-center">
            {["iocs", "cert", "inventory", "policies", "audit", "kpi"].map((key) => (
              <Nav.Link
                key={key}
                onClick={() => handleSelect(key)}
                className={`nav-link-custom ${isActive(key) ? "nav-link-active" : ""}`}
              >
                {key.toUpperCase()}
              </Nav.Link>
            ))}

            {/* STATS Dropdown Inline in Navbar */}
            <Dropdown as="span" className="nav-item">
			  <Dropdown.Toggle
				as="a"
				className={`nav-link nav-link-custom ${location.pathname.startsWith("/stats") ? "nav-link-active" : ""}`}
				id="stats-dropdown"
				style={{ cursor: "pointer" }}
			  >
				STATS
			  </Dropdown.Toggle>

			  <Dropdown.Menu id="account-dropdown" className="bg-dark">
				<Dropdown.Item onClick={() => handleSelect("stats/threats")}>
				  <i className="bi bi-bug-fill me-2"></i> Threats & Vulnerabilities
				</Dropdown.Item>
				<Dropdown.Item onClick={() => handleSelect("stats/posture")}>
				  <i className="bi bi-shield-check me-2"></i> Security Posture
				</Dropdown.Item>
			  </Dropdown.Menu>
			</Dropdown>
          </Nav>

          <Dropdown align="end">
            <Dropdown.Toggle as={CustomToggle}>
              <img
                src={user?.avatar_url || "/img/avatar_default.jpg"}
                alt="Avatar"
                className={`dropdown-avatar me-2 ${user?.is_admin ? "admin" : ""}`}
              />
              {user?.display_name || "Account"}
            </Dropdown.Toggle>

            <Dropdown.Menu id="account-dropdown" className="bg-dark">
              <Dropdown.Item onClick={() => handleSelect("profile")}>
                <i className="bi bi-person-fill me-2"></i> Profile
              </Dropdown.Item>
			  <Dropdown.Item onClick={() => handleSelect("tools")}>
                <i className="bi bi-tools me-2"></i> Tools
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleSelect("settings")}>
                <i className="bi bi-gear-fill me-2"></i> Settings
              </Dropdown.Item>

              <Dropdown.Divider />
              <Dropdown.Item onClick={() => handleSelect("logout")} className="text-danger">
                <i className="bi bi-box-arrow-right me-2"></i> Log Out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
